module.exports = {
  prismicRepo: process.env.GATSBY_PRISMIC_REPOSITORY_NAME,
  defaultLanguage: process.env.GATSBY_DEFAULT_LOCALE,
}
